import { baseEntityReducers, baseInitialState } from './base/baseModelStore';
import { fetchEntity } from './base/baseModelThunks';
import { ModelReducers } from './modelReducers';
import { createSlice } from '@reduxjs/toolkit';
import { httpClient } from '../infrastructure/http/HttpClient';
import { AxiosResponseTransformer } from 'axios';
import { DeviceDetails } from '@api-model/models';

export type SiteDeviceDetails = DeviceDetails & { siteId: string };

const slice = createSlice({
  name: ModelReducers.deviceDetails,
  initialState: baseInitialState<SiteDeviceDetails>(),
  reducers: {
    ...baseEntityReducers((dd) => (dd as SiteDeviceDetails).siteId),
  },
});

const thunks = {
  getEntity: fetchEntity<SiteDeviceDetails>(ModelReducers.deviceDetails, slice.actions, (siteId: string) =>
    httpClient.get(`chambers/${siteId}/device`, {
      transformResponse: (httpClient.defaults.transformResponse as AxiosResponseTransformer[]).concat(
        (data: DeviceDetails) => {
          return { ...data, siteId };
        }
      ),
    })
  ),
};

export const deviceDetailsEntity = {
  reducer: slice.reducer,
  actions: slice.actions,
  thunks,
} as {
  reducer: typeof slice.reducer;
  actions: typeof slice.actions;
  thunks: typeof thunks;
};
